__turbopack_context__.v({
  "component": "style-module-scss-module__8gHI5G__component",
});
